module.exports = __webpack_public_path__ + "img/no_content.3d0ef172.png";